/**
 * Ekrany panelu w kontekście automatycznej aktualizacji (rdzeń reguł: `@nexops/shared` → `app-update.ts`).
 *
 * SAFE_ROUTES — ekrany, które wolno wymienić bez pytania po powrocie do karty: pulpity, listy i analizy tylko do
 * odczytu. Dokładne ścieżki, celowo: LISTA DOZWOLONYCH. Panel bywa otwarty godzinami, a część ekranów ma stan, którego
 * żaden zapis nie trzyma (rozpoczęty wniosek, ustawienia, odpowiedź w czacie, wygenerowana analiza AI) — takich ekranów
 * tu nie ma, nawet gdy wyglądają na listy. Sprawdzenie pól z tekstem i otwartych okien to druga siatka, nie pierwsza.
 *
 * NOT_SAFE_ROUTES — świadoma decyzja „tylko komunikat”. Strażnik (`app-update-screens.test.mjs`) pilnuje, że każda
 * trasa z `app/router.tsx` jest na jednej z dwóch list — nowy ekran musi dostać jawną decyzję.
 */
export const SAFE_ROUTES: readonly string[] = [
  '/', // Mój dzień
  '/customers', // LISTA — nie karta klienta
  '/leads',
  '/visits',
  '/tasks',
  '/notifications',
  '/logistics',
  '/logistics/deliveries',
  '/logistics/routes',
  '/logistics/problems',
  '/logistics/fulfilment',
  '/fleet/vehicles',
  '/fleet/leases',
  '/fleet/logbooks',
  '/fleet/my-logbooks',
  '/fleet/fuel',
  '/fleet/expenses',
  '/fleet/incidents',
  '/fleet/checklists',
  '/fleet/service',
  '/fleet/analytics',
  '/fleet/routes',
  '/manager',
  '/analytics/board',
  '/analytics/customers',
  '/analytics/products',
  '/analytics/team',
  '/analytics/rep',
  '/analytics/rep-sales',
  '/analytics/activity',
  '/analytics/funnel',
  '/analytics/team-reports',
  '/analytics/bonus',
  '/analytics/margin',
  '/analytics/profitability',
  '/analytics/receivables',
  '/analytics/forecasts',
  '/admin/live',
  '/admin/audit',
  '/integrations/erp-sync', // Dziennik synchronizacji: podgląd; uruchomiony przebieg trwa na serwerze niezależnie od ekranu
  '/insurance', // Pulpit ubezpieczeń (tylko odczyt) — reszta modułu ma edycję i decyzje
  '/insurance/analytics', // Szkodowość (tylko odczyt)
  '/quality/analytics', // Analityka reklamacji (tylko odczyt)
  '/legal',
  '/help',
  '/costs', // Koszty z księgi: tylko odczyt (zakładki i okres w URL)
  '/purchasing', // Prognoza zakupów, do zamówienia, dostawcy: tylko odczyt (filtry w URL)
  '/sales/commissions', // Prowizje: tylko odczyt
  '/surveys', // LISTA szablonów ankiet - nie edytor
];

/** Wzorce tras (jak w routerze) świadomie poza listą bezpiecznych: edycja, kreatory, czat, ustawienia, szczegóły. */
export const NOT_SAFE_ROUTES: readonly string[] = [
  '/quality', // Pulpit jakości: kolejka reklamacji otwiera panel ze zmianą statusu
  '/logistics/reports', // ustawienia wysyłki paczki (formularz)
  '/finance/collections', // sprawy w kancelarii, import factoringu
  '/surveys/new', // kreator ankiety
  '/surveys/:id', // edytor ankiety
  '/surveys/:id/results', // szczegóły (trasa z parametrem)
  '/integrations/erp-outbox', // nowy token integracji jest pokazywany tylko raz
  '/integrations/erp-sync/runs/:id', // szczegóły (trasa z parametrem)
  '/login',
  '/set-password',
  '/customers/:id',
  '/invoice-comparisons/:id', // NX-417: potwierdzanie dopasowań i przeliczników — nie wymieniać pod ręką
  '/sales/orders', // NX-419: kolejka Biura zamówień — okno „Odrzuć z powodem” z wpisywanym powodem
  '/my-daily-report',
  '/alerts', // przekierowanie
  '/chat/:conversationId?',
  '/workflow',
  '/workflow/new',
  '/workflow/requests/:id',
  '/logistics/routes/:id',
  '/logistics/optimization',
  '/fleet', // przekierowanie
  '/fleet/vehicles/:id',
  '/fleet/leases/:id',
  '/fleet/logbooks/:id',
  '/fleet/my-logbooks/:id',
  '/fleet/fuel/:id',
  '/fleet/expenses/:id',
  '/fleet/incidents/:id',
  '/fleet/checklists/:id',
  '/fleet/templates',
  '/fleet/settings',
  '/fleet/routes/:id',
  '/fleet/integration',
  '/fleet/integration/runs/:id',
  '/fleet/insights',
  '/admin/gdpr',
  '/mbr',
  '/admin/settings',
  '/admin/dictionaries',
  '/account',
  '/admin/users',
  '/admin/roles',
  '/admin/ai',
  '/analytics',
  '/results/rep-sales', // przekierowanie
  '/analytics/profitability/routes/:id',
  '/analytics/:section',
  '/planner', // grafik z edycją zmian, zaznaczeniem i niezapisanym projektem
  '/planner/setup', // edycja szablonów czynności i atrybutów zmian
  '/worktime', // korekty wpisów RCP, profile i okresy
  '/worktime/my', // odbicie wejścia / wyjścia
  '/worktime/settings', // edycja reguł czasu pracy
  '/leave', // decyzje o wnioskach z komentarzem, edycja wymiaru, powiązania z InsERT (NX-421)
  '/insurance/policies', // portfel z edycją polis
  '/insurance/import', // podgląd importu przed zatwierdzeniem
  '/insurance/queue', // decyzje kwalifikacji, także zbiorcze
  '/insurance/claims',
  '/insurance/claims/:id',
  '/insurance/tenders',
  '/insurance/tenders/:id',
  '/insurance/settings',
  '/finance/cashflow', // wpisywanie stanu rachunków bankowych (okno z formularzem)
  '/quality/complaints', // zmiana statusu z komentarzem w panelu bocznym
  '/quality/events', // formularz zdarzenia
  '/quality/suppliers', // nowe uzgodnienie z dostawcą
  '*',
  '/warehouse', // korekta norm, ustawienia, import CSV z WMS
];
